import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "İhracatçı birlikleri e-imza portalına hoş geldiniz.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Bu sistem üzerinden birliklere gönderdiğiniz belgeleri e-imzanız ile imzalayabilirsiniz. İmzalama talepleri size e-posta ile iletilmektedir. Size gelen e-postada yer alan imza talebine ait bağlantıya tıklayarak belgelerinizi elektronik imza ile imzalayabilirsiniz. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_title_desc = _resolveComponent("app-title-desc")!
  const _component_app_card = _resolveComponent("app-card")!
  const _component_app_install_signer = _resolveComponent("app-install-signer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_card, { class: "card-clean" }, {
      default: _withCtx(() => [
        _createVNode(_component_app_title_desc, {
          title: "TİM E-İMZA PORTALI",
          class: "dark lg"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_app_install_signer)
  ]))
}